
        import * as module0 from './controllers/dark_mode_controller.js'
        const modules = {
            "./controllers/dark_mode_controller.js": module0,
        };
        export default modules;
      